export default "__VITE_ASSET__Mtq8V5Ah__"